import { createContext, useContext, useState, useCallback, useMemo } from "react";
import translations from "@/translations";

const LanguageContext = createContext();

export const LANGUAGES = [
  { code: "en", name: "English", flag: "\uD83C\uDDEC\uD83C\uDDE7" },
  { code: "es", name: "Espa\u00f1ol", flag: "\uD83C\uDDEA\uD83C\uDDF8" },
  { code: "fr", name: "Fran\u00e7ais", flag: "\uD83C\uDDEB\uD83C\uDDF7" },
  { code: "de", name: "Deutsch", flag: "\uD83C\uDDE9\uD83C\uDDEA" },
  { code: "zh", name: "\u4E2D\u6587", flag: "\uD83C\uDDE8\uD83C\uDDF3" },
];

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("en");

  const t = useCallback(
    (key) => {
      const keys = key.split(".");
      let value = translations[lang];
      for (const k of keys) {
        value = value?.[k];
      }
      if (value === undefined) {
        let fallback = translations.en;
        for (const k of keys) {
          fallback = fallback?.[k];
        }
        return fallback;
      }
      return value;
    },
    [lang]
  );

  const contextValue = useMemo(
    () => ({ lang, setLang, t, LANGUAGES }),
    [lang, t]
  );

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
